// 该文件专门用于创建整个应用的路由器
import VueRouter from 'vue-router'
//引入组件
import index from '../view/index.vue'
//创建并暴露一个路由器
const router =  new VueRouter({
	mode: 'history',
	base: '/hbbwyxyxpro/',
	routes:[
		{
			path:'/',
			redirect: '/index'
		},
		{
			name:'index',
			path:'/index',
			component:index
		}
		
		
		
	]
})


export default router;
